<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CHAPTER1" id="uQnDLTCpbRWGcYybFsdqO54">ACKNOWLEDGMENTS</p>
<p class="FIRSTPARAGRAPH">I owe a very special round of gratitude to:</p>
<p class="Normal">Eileen O’Callaghan, my loving and supportive wife, who shares life in so many wonderful ways; Matt Bialer, a magician of an agent, and trusted friend; Michaela Hamilton, a conscientious, and extremely talented editor, who is a true delight to work with; Dick Marek, a man from whom I have learned much; Stephen Ohayon, Ph.D., a true gentleman, who inspired me tirelessly from day one; Barry Richman, M.D.; Marla Feder; the Group; and of course, Noreen Nolan, a gifted woman who shares her gift with me.</p>
<p class="Normal">Lieutenant William F. Nevins, CDS, Commanding Off­icer of the Queens Homicide Squad, (Retired) for his expert technical advice and skillful guidance. He represents NYPD at its finest.</p>
<p class="Normal">My dear friend Priscilla Winkler, whose support through the years has been steadfast.</p>
<p class="Normal _idGenParaOverride-1">And to my loving granddaughter, Kristin, who calls me PaPa and watches me melt.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?56301fc1